import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, House } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';

const QuotationSuccessPage = () => (
  <main
    data-testid="quotation-success-page"
    className="pt-24 pb-16 min-h-screen bg-[#F7F5F2] flex items-center"
    dir="rtl"
  >
    <div className="max-w-xl mx-auto px-4 w-full">
      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        className="bg-white rounded-[24px] shadow-sm border border-[#E6E0D6] p-8 text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 280, damping: 20, delay: 0.2 }}
          className="w-20 h-20 rounded-full bg-[#4A641F] flex items-center justify-center mx-auto mb-6"
        >
          <CheckCircle size={44} weight="fill" className="text-white" />
        </motion.div>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#1F3D2B] mb-3 font-['IBM_Plex_Sans_Arabic']">
          شكراً لكم 🌿
        </h1>
        <p className="text-[#3D512D] leading-9">
          شكراً لكم، تم استلام طلبكم بنجاح. سيتم مراجعة البيانات والتواصل معكم
          خلال يوم عمل واحد إلى يومي عمل لتحديد نطاق العمل ومناقشة الاحتياج،
          ثم إرسال عرض السعر المناسب.
        </p>
        <div className="mt-8">
          <Link to="/">
            <Button
              variant="outline"
              className="border-[#D8D2C8] text-[#1F3D2B] rounded-xl px-6 py-3 inline-flex items-center gap-2"
            >
              <House size={16} />
              العودة للرئيسية
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  </main>
);

export default QuotationSuccessPage;
